/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ method: NonNullable<unknown> }} Client_Banking_Method_LabelInputs */

const en_client_banking_method_label = /** @type {(inputs: Client_Banking_Method_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.method === "pix") return /** @type {LocalizedString} */ (`PIX`);
	if (i?.method === "bank") return /** @type {LocalizedString} */ (`Bank`);
	return /** @type {LocalizedString} */ (`${i?.method}`)
	
};

const pt_br2_client_banking_method_label = /** @type {(inputs: Client_Banking_Method_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.method === "pix") return /** @type {LocalizedString} */ (`PIX`);
	if (i?.method === "bank") return /** @type {LocalizedString} */ (`Banco`);
	return /** @type {LocalizedString} */ (`${i?.method}`)
	
};

/**
* | method | output |
* | --- | --- |
* | "pix" | "PIX" |
* | "bank" | "Bank" |
* | * | "{method}" |
*
* @param {Client_Banking_Method_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_banking_method_label = /** @type {((inputs: Client_Banking_Method_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Banking_Method_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_banking_method_label(inputs)
	return pt_br2_client_banking_method_label(inputs)
});